const dateAddedFormatter = new Intl.DateTimeFormat('en-GB')

export const formatDateAdded = (isoDate: string) =>
  dateAddedFormatter.format(new Date(isoDate))
